export const LOAD_CHART_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_CHART_WIDGET_DATA_REQUEST";
export const LOAD_INTERFACE_CHART_DATA_REQUEST = "[DASHBOARD] LOAD_INTERFACE_CHART_DATA_REQUEST";
